import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import TableToExcel from '@linways/table-to-excel';
import { useForm } from "react-hook-form";
import * as React from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';
import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as leadActions from "../../actions/leadActions";
// ----------------------------------------------------------------------
const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));
// ----------------------------------------------------------------------
const CamApprovalHistoryPage = (props) => {
 // const { leadId, id } = useParams();
  const location = useLocation();
  const {leadInfo, actions, usersData, fetchLeadIdBankStatement,formCAMValues,camApprovalHistory} = props;
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate(); 
  const [file, setFile] = useState('');
    
    
useEffect(() => {
 }, [ ]); 

  return (
    <>
       <div className="row" >
        

       <div className='col-md-12'>
                    <h5 className='fw-bold mb-3 mt-md-0 mt-3 ms-md-3'>All History</h5>
                    <div className="history-tl-container rounded ms-md-3">
                        <ul className="tl">
                            {camApprovalHistory.length > 0 && camApprovalHistory.map(idata => (
                                <li className="tl-item">
                                    {idata.action_status === '1' ? (
                                        <div className="timestamp-history yes d-none-">Approved<i className="bi bi-caret-right-fill">&nbsp;</i></div>
                                    ) : (
                                        idata.action_status === '2' ? (<div className="timestamp-history no d-none-">Rejected<i className="bi bi-caret-right-fill">&nbsp;</i></div>) : (<></>)
                                    )}

                                     <div className="item-date">{idata.DateOfInteraction}</div>
                                    <div className="item-user">{idata.createdByName}</div>
                                     <div className="item-detail">{idata.notes}</div>
                                </li>
                            ))}
                            {camApprovalHistory.length < 1 ? (
                                <li className="tl-item">
                                    <div className="item-title">No history</div>
                                </li>
                            ) : (
                                <></>
                            )}
                        </ul>
                    </div>
                </div>
       </div>
    </>
  );
}


function mapStateToProps(state) {
  return {
    usersData: state.usersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default, leadBankStatementActions.default, leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CamApprovalHistoryPage);
